import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { capitalize } from "../../utils/helpers";

const styles = StyleSheet.create({
  page: {
    padding: 36,
    fontSize: 10,
    fontFamily: "Helvetica",
    color: "#111827",
    lineHeight: 1.5,
  },

  logo: {
    width: 90,
    marginBottom: 10,
  },

  title: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: 14,
  },
  leftAlign: {
    textAlign: "left",
    fontSize: 9,
    color: "#6B7280",
    marginBottom: 1,
  },

  meta: {
    textAlign: "center",
    fontSize: 9,
    color: "#6B7280",
    marginBottom: 20,
  },

  divider: {
    borderBottom: "1px solid #E5E7EB",
    marginVertical: 12,
  },

  section: {
    marginBottom: 14,
  },

  sectionTitle: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 6,
    color: "#374151",
  },

  twoCol: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  col: {
    width: "48%",
  },
  label: {
    color: "#6B7280",
    marginBottom: 6,
  },

  tableHeader: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
    paddingBottom: 6,
    marginBottom: 6,
    marginTop: 3,
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    borderBottom: "1px solid #F3F4F6",
  },
  colIndex: { width: "8%" },
  colService: { width: "62%" },
  colPrice: { width: "30%", textAlign: "right" },

  totalBox: {
    marginTop: 10,
    paddingTop: 8,
    borderTop: "1px solid #000",
    alignItems: "flex-end",
  },
  totalText: {
    fontSize: 12,
    fontWeight: "bold",
  },

  footer: {
    marginTop: 30,
    textAlign: "center",
    fontSize: 9,
    color: "#6B7280",
  },
});
const InfoRow = ({ label, value }) => (
  <View
    style={{
      flexDirection: "row",
      marginBottom: 3,
    }}
  >
    {/* Label column */}
    <Text style={[styles.label, { width: "30%" }]}>{label}</Text>

    {/* Value column */}
    <Text style={{ width: "60%" }}>{value}</Text>
  </View>
);

const InvoiceDocument = ({ booking }) => {
  // console.log("Rendering InvoiceDocument with booking:", booking);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.twoCol}>
          <View>
            <Text style={styles.title}>INVOICE</Text>
            <Text style={styles.leftAlign}>
              Invoice ID: {booking.bookingId}
            </Text>
            <Text style={styles.leftAlign}>
              Invoice Date: {new Date().toLocaleDateString()}
            </Text>
          </View>
          <Image src="/logo.png" style={styles.logo} />
        </View>

        <View style={styles.divider} />

        {/* ---------- Customer & Booking ---------- */}
        <View style={[styles.section, styles.twoCol]}>
          {/* Customer */}
          <View style={styles.col}>
            <Text style={styles.sectionTitle}>Customer Details</Text>

            <InfoRow label="Name" value={booking.customerName} />
            <InfoRow label="Phone" value={booking.phone} />
            <InfoRow label="Email" value={booking.email} />
            <InfoRow label="Address" value={booking?.raw?.location?.address?.formatted} />
          </View>

          {/* Booking */}
          <View style={styles.col}>
            <Text style={styles.sectionTitle}>Booking Details</Text>

            <InfoRow label="Status" value={capitalize(booking.status)} />
            <InfoRow
              label="Booking Date"
              value={new Date(booking.bookingDate).toDateString()}
            />
            <InfoRow
              label="Assigned Staff"
              value={booking.assignedStaff || "—"}
            />
            <InfoRow label="Payment Mode" value={booking.settledVia || "—"} />
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Services</Text>

          <View style={styles.tableHeader}>
            <Text style={styles.colIndex}>#</Text>
            <Text style={styles.colService}>Service</Text>
            <Text style={styles.colPrice}>Price</Text>
          </View>

          {booking.services.map((service, index) => {
            const serviceName = service?.serviceId?.name || "Service";
            const displayName = service.brand
              ? `${serviceName} (${service.brand})`
              : serviceName;

            const qty = service.qty || 1;
            const price = service.price || 0;
            const lineTotal = price * qty;

            return (
              <View key={index} style={styles.tableRow}>
                <Text style={styles.colIndex}>{index + 1}</Text>

                <Text style={styles.colService}>
                  {displayName}
                  {qty > 1 ? ` × ${qty}` : ""}
                </Text>

                <Text style={styles.colPrice}>{lineTotal}</Text>
              </View>
            );
          })}

          <View style={styles.totalBox}>
            <Text style={styles.totalText}>
              Total Amount: {booking.totalAmount}
            </Text>
          </View>
        </View>

        <Text style={styles.footer}>
          Thank you for choosing us.
          {"\n"}
          This is a system-generated invoice and does not require a signature.
        </Text>
      </Page>
    </Document>
  );
};

export default InvoiceDocument;
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";
// import { capitalize } from "../../utils/helpers";

// const styles = StyleSheet.create({
//   page: {
//     padding: 36,
//     fontSize: 10,
//     fontFamily: "Helvetica",
//     color: "#111827",
//     lineHeight: 1.5,
//   },

//   logo: {
//     width: 90,
//     marginBottom: 10,
//   },

//   title: {
//     fontSize: 20,
//     fontWeight: "bold",
//     textAlign: "left",
//     marginBottom: 14,
//   },
//   leftAlign: {
//     textAlign: "left",
//     fontSize: 9,
//     color: "#6B7280",
//     marginBottom: 1,
//   },

//   meta: {
//     textAlign: "center",
//     fontSize: 9,
//     color: "#6B7280",
//     marginBottom: 20,
//   },

//   divider: {
//     borderBottom: "1px solid #E5E7EB",
//     marginVertical: 12,
//   },

//   section: {
//     marginBottom: 14,
//   },

//   sectionTitle: {
//     fontSize: 11,
//     fontWeight: "bold",
//     marginBottom: 6,
//     color: "#374151",
//   },

//   twoCol: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//   },
//   col: {
//     width: "48%",
//   },
//   label: {
//     color: "#6B7280",
//     marginBottom: 6,
//   },

//   tableHeader: {
//     flexDirection: "row",
//     borderBottom: "1px solid #000",
//     paddingBottom: 6,
//     marginBottom: 6,
//     marginTop: 3,
//     fontWeight: "bold",
//   },
//   tableRow: {
//     flexDirection: "row",
//     paddingVertical: 4,
//     borderBottom: "1px solid #F3F4F6",
//   },
//   colIndex: { width: "8%" },
//   colService: { width: "62%" },
//   colPrice: { width: "30%", textAlign: "right" },

//   totalBox: {
//     marginTop: 10,
//     paddingTop: 8,
//     borderTop: "1px solid #000",
//     alignItems: "flex-end",
//   },
//   totalText: {
//     fontSize: 12,
//     fontWeight: "bold",
//   },

//   footer: {
//     marginTop: 30,
//     textAlign: "center",
//     fontSize: 9,
//     color: "#6B7280",
//   },
// });
// const InfoRow = ({ label, value }) => (
//   <View
//     style={{
//       flexDirection: "row",
//       marginBottom: 3,
//     }}
//   >
//     {/* Label column */}
//     <Text style={[styles.label, { width: "30%" }]}>{label}</Text>

//     {/* Value column */}
//     <Text style={{ width: "60%" }}>{value}</Text>
//   </View>
// );

// const InvoiceDocument = ({ booking }) => {
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <View style={styles.twoCol}>
//           <View>
//             <Text style={styles.title}>INVOICE</Text>
//             <Text style={styles.leftAlign}>
//               Invoice ID: {booking.bookingId}
//             </Text>
//             <Text style={styles.leftAlign}>
//               Invoice Date: {new Date().toLocaleDateString()}
//             </Text>
//           </View>
//           <Image src="/logo.png" style={styles.logo} />
//         </View>

//         <View style={styles.divider} />

//         {/* ---------- Customer & Booking ---------- */}
//         <View style={[styles.section, styles.twoCol]}>
//           {/* Customer */}
//           <View style={styles.col}>
//             <Text style={styles.sectionTitle}>Customer Details</Text>

//             <InfoRow label="Name" value={booking.customerName} />
//             <InfoRow label="Phone" value={booking.phone} />
//             <InfoRow label="Email" value={booking.email} />
//             <InfoRow label="Address" value={booking.address} />
//           </View>

//           {/* Booking */}
//           <View style={styles.col}>
//             <Text style={styles.sectionTitle}>Booking Details</Text>

//             <InfoRow label="Status" value={capitalize(booking.status)} />
//             <InfoRow
//               label="Booking Date"
//               value={new Date(booking.bookingDate).toDateString()}
//             />
//             <InfoRow
//               label="Assigned Staff"
//               value={booking.assignedStaff || "—"}
//             />
//             <InfoRow label="Payment Mode" value={booking.paymentMode || "—"} />
//           </View>
//         </View>

//         <View style={styles.section}>
//           <Text style={styles.sectionTitle}>Services</Text>

//           <View style={styles.tableHeader}>
//             <Text style={styles.colIndex}>#</Text>
//             <Text style={styles.colService}>Service</Text>
//             <Text style={styles.colPrice}>Price</Text>
//           </View>

//           {booking.services.map((service, index) => (
//             <View key={index} style={styles.tableRow}>
//               <Text style={styles.colIndex}>{index + 1}</Text>
//               <Text style={styles.colService}>{service?.serviceId?.name}</Text>
//               <Text style={styles.colPrice}>{service?.price}</Text>
//             </View>
//           ))}

//           <View style={styles.totalBox}>
//             <Text style={styles.totalText}>
//               Total Amount: {booking.totalAmount}
//             </Text>
//           </View>
//         </View>

//         <Text style={styles.footer}>
//           Thank you for choosing us.
//           {"\n"}
//           This is a system-generated invoice and does not require a signature.
//         </Text>
//       </Page>
//     </Document>
//   );
// };

// export default InvoiceDocument;
